import React, { createContext, useState, useEffect } from "react";

// Create the UserContext
export const UserContext = createContext();

// Create a provider component
export const UserProvider = ({ children }) => {
    // Get the username from localStorage if available
    const storedUsername = localStorage.getItem("username") || "";

    const [username, setUsername] = useState(storedUsername);

    // Update localStorage whenever the username changes
    useEffect(() => {
        if (username) {
            localStorage.setItem("username", username);
        }
    }, [username]);

    return (
        <UserContext.Provider value={{ username, setUsername }}>
            {children}
        </UserContext.Provider>
    );
};
